import { render, staticRenderFns } from "./ShareCustomersUser.vue?vue&type=template&id=83055890"
import script from "./ShareCustomersUser.vue?vue&type=script&lang=js"
export * from "./ShareCustomersUser.vue?vue&type=script&lang=js"
import style0 from "./ShareCustomersUser.vue?vue&type=style&index=0&id=83055890&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports